<template>
  <div>
    <div class="app-align-items-center mb-2">
      <BaseButton
        v-if="countStepSchema > 0"
        :has-icon="true"
        color="primary"
        class="pa-4 ma-0"
        size="x-small"
        @click="backFilterSchema()"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </BaseButton>
      <BaseInput
        v-model="modelFilterSchema"
        label="Filtrar schemas de protobuf"
        class="mx-2"
        style="min-width: 100px;"
        clearable
        dense
        @input="filterSchemas(modelFilterSchema)"
      />
    </div>
    <p
      v-if="countStepSchema == 2 && filteredSchemaDetailsList.length"
      class="d-flex justify-space-between mr-2"
    >
      <span>NAME</span>
      <span>TYPE</span>
      <span>NUMBER</span>
    </p>
    <v-virtual-scroll
      v-if="countStepSchema !== 2 && filteredSchemaList.length"
      :items="filteredSchemaList"
      :height="fullHeight ? 1000 : 340"
      item-height="32"
    >
      <template v-slot:default="{ item }">
        <v-list-item
          class="pa-0"
          style="min-height:unset;"
        >
          <v-list-item-action class="ma-1">
            <BaseButton
              :has-icon="true"
              color="primary"
              class="ma-0 pa-3"
              size="x-small"
              @click="getSchemaMessage(item)"
            >
              <v-icon>mdi-chevron-down</v-icon>
            </BaseButton>
          </v-list-item-action>

          <v-list-item-content class="py-1">
            <v-list-item-title style="font-size: 13px;">
              {{ item }}
            </v-list-item-title>
          </v-list-item-content>

          <v-list-item-action class="ma-1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <BaseButton
                  :has-icon="true"
                  color="primary"
                  class="ma-0 pa-3"
                  size="x-small"
                  v-bind="attrs"
                  v-on="on"
                  @click="insertText(item)"
                >
                  <v-icon>mdi-chevron-right</v-icon>
                </BaseButton>
              </template>
              <span>Colar na caixa de script</span>
            </v-tooltip>
          </v-list-item-action>
        </v-list-item>
        <v-divider />
      </template>
    </v-virtual-scroll>
    <v-virtual-scroll
      v-else-if="filteredSchemaDetailsList.length"
      :items="filteredSchemaDetailsList"
      :height="fullHeight ? 1000 : 340"
      item-height="32"
    >
      <template v-slot:default="{ item }">
        <v-list-item
          class="pa-0"
          style="min-height:unset;"
        >
          <v-list-item-content class="py-1">
            <v-list-item-title
              style="font-size: 13px;"
              class="d-flex justify-space-between"
            >
              <span>{{ item.name }}</span>
              <span>{{ item.type }}</span>
              <span>{{ item.number }}</span>
            </v-list-item-title>
          </v-list-item-content>

          <v-list-item-action class="ma-1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <BaseButton
                  :has-icon="true"
                  color="primary"
                  class="ma-0 pa-3"
                  size="x-small"
                  v-bind="attrs"
                  v-on="on"
                  @click="insertText(item.name)"
                >
                  <v-icon>mdi-chevron-right</v-icon>
                </BaseButton>
              </template>
              <span>Colar na caixa de script</span>
            </v-tooltip>
          </v-list-item-action>
        </v-list-item>
        <v-divider />
      </template>
    </v-virtual-scroll>
    <p v-else>
      Nenhum schema encontrado.
    </p>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  props:{
    fullHeight:{
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({
    schemaList: [],
    nameSchema: '',
    countStepSchema: 0,
    schemaMessageDetails: [],
    filteredSchemaDetailsList: [],
    schemaMessageList: [],
    filteredSchemaList: [],
    modelFilterSchema: '',
  }),

  created(){
    this.getSchema()
  },

  methods: {
    ...mapActions(['apiGetSchemaMessages', 'apiGetSchemaMessage']),
    backFilterSchema() {
      this.nameSchema = ''

      if(this.countStepSchema == 1){
        this.filteredSchemaList = this.schemaList
      }
      else {
        this.filteredSchemaList = this.schemaMessageList
      }
      this.countStepSchema--
    },
    insertText(value) {
      this.$emit('insert-value', value)
    },
    async filterSchemas(value){
      if(!value){
        this.filteredSchemaList = this.schemaList
      } else if(this.countStepSchema == 0 || this.countStepSchema == 1){
        let result = await this.apiGetSchemaMessages(value)
        this.schemaMessageList = result
        this.filteredSchemaList = result
      } else {
        this.filteredSchemaDetailsList = this.schemaMessageDetails.filter((schema) => schema.name.includes(value))
      }
    },
    async getSchema() {
      this.schemaMessageList = []
      this.schemaMessageDetails = []

      let result = await this.apiGetSchemaMessages()
      this.schemaList = result
      this.filteredSchemaList = result
    },
    async getSchemaMessage(payload){
      this.modelFilterSchema = ''
      let result = await this.apiGetSchemaMessage(payload)

      if(result && result.field){
        this.countStepSchema = 2
        this.schemaMessageDetails = result.field
        this.filteredSchemaDetailsList = result.field
      } else {
        this.countStepSchema++
        this.schemaMessageList = result
        this.filteredSchemaList = result
      }
    },
  }
}
</script>
